import React, { Suspense } from 'react'
import get from 'lodash/get'
import set from 'lodash/set'
import cloneDeep from 'lodash/cloneDeep'
import { RiArrowGoBackFill } from 'react-icons/ri'
import { Form, Label, Button } from 'reactstrap'
import { DateInput } from 'components/sites/DateInput'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { rollOutAction } from 'actions/dataManagement'
import Notifications from 'react-notification-system-redux'

const notifySuccess = (t) =>
  Notifications.success({
    title: t('dataManagement.notify.rolloutSuccess'),
    position: 'bl',
    autoDismiss: 3,
})
const notifyError = (t) =>
  Notifications.error({
    title: t('dataManagement.notify.error'),
    position: 'bl',
    autoDismiss: 3,
 })


export const Rollout = ({ onBack, selectedIds }) => {
    const [data, setData] = React.useState({})
    const [touched, setTouched] = React.useState(false)
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const loading = false

    const onChange = React.useCallback(
        (path, value) => {
        setTouched(true)
        const newData = cloneDeep(data)
        set(newData, path, value)
        setData(newData)
        },
        [data]
    )
    
    const handleSubmit = React.useCallback(
        async (e) => {
            e.preventDefault()

            const payload = {
                PdlNums: selectedIds,
                Start: data.DateEntree,
                End: data.DateSortie,
            };
            
            try {
                await dispatch(rollOutAction(payload));

                dispatch(notifySuccess(t));
                setTouched(false);
            } catch (error) {
                dispatch(notifyError(t));
                console.error("Import failed:", error);
            }
        },
        [data, dispatch] 
    )
    
    return (
        <section style={{ display: 'flex', flexDirection: 'column', gap: '2rem', alignItems: 'flex-start' }}>
        <Button
            style={{color: 'black', background: '#98D2DD', border: '#98D2DD'}}
            onClick={onBack}
        >
            <RiArrowGoBackFill/>
            {t('dataManagement.back')}
        </Button>
        <div>
            <Form onSubmit={handleSubmit}>
            <div>
                <Label>
                    <span className="mr-2 font-weight-bold">{t('dataManagement.previsionStartDate')}</span>
                    <DateInput
                        value={get(data, 'DateEntree', '')}
                        onChange={(value) => onChange('DateEntree', value)}
                        disabled={loading}
                    />
                </Label>
            </div>

            <div>
                <Label>
                    <span className="mr-2 font-weight-bold">{t('dataManagement.previsionEndDate')}</span>
                    <DateInput
                        value={get(data, 'DateSortie', '')}
                        onChange={(value) => onChange('DateSortie', value)}
                        disabled={loading}
                    />
                </Label>
            </div>
            <div>
                <Label>
                    <span className="mr-2 font-weight-bold">{t('dataManagement.rollOutNote')}</span>
                </Label>
            </div>

            <Button
                type="submit"
                disabled={loading || !touched}
                style={{color: 'black', background: '#98D2DD', border: '#98D2DD', marginTop: '1rem'}}
            >
                {t('dataManagement.launchRollout')}
            </Button>
            </Form>
        </div>
       
        </section>
        )
}